export const isMobileDevice = () => typeof window === 'object' ? 'ontouchstart' in window : false;
//# sourceMappingURL=checkdevice.js.map